import { heroCopy } from "@/mocks/home";
import InteractiveImageCanvas from "./InteractiveImageCanvas";

export default function Hero() {
  return (
    <section
      id="top"
      className="w-full h-full bg-background-50 border-y-4 border-foreground-950 flex flex-col"
    >
      {/* Text row — compact band at top */}
      <div className="border-b-4 border-foreground-950 grid grid-cols-1 lg:grid-cols-12">
        {/* Headline */}
        <div className="lg:col-span-7 px-6 md:px-10 lg:px-14 py-6 md:py-8 lg:border-r-4 lg:border-foreground-950 flex items-center bg-[#FFE94A]">
          <h1 className="font-heading font-medium italic text-foreground-950 leading-[0.95] tracking-[-0.035em] text-[44px] md:text-[60px] lg:text-[76px]">
            {heroCopy.headline}
          </h1>
        </div>

        {/* Description + CTA */}
        <div className="lg:col-span-5 px-6 md:px-10 lg:px-14 py-6 md:py-8 flex flex-col sm:flex-row lg:flex-col gap-4 sm:gap-8 lg:gap-4 sm:items-center lg:items-start justify-between">
          <p className="font-sans text-foreground-700 text-[13px] md:text-[14px] leading-[1.5] tracking-[-0.005em] max-w-[320px]">
            {heroCopy.description}
          </p>
          <a
            href={heroCopy.cta.href}
            className="group inline-flex items-center gap-2 font-sans text-[11px] tracking-[0.12em] uppercase text-foreground-950 cursor-pointer whitespace-nowrap border-b-2 border-foreground-950 pb-1 self-start"
          >
            {heroCopy.cta.label}
            <i className="ri-arrow-right-up-line w-4 h-4 inline-flex items-center justify-center text-[14px] transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </div>

      {/* Image — takes the rest of the viewport */}
      <div className="relative w-full flex-1 overflow-hidden">
        <InteractiveImageCanvas
          src="https://static.readdy.ai/image/ef1aae41220ad17a1705abffff22a58b/1a6bd577a2da148d5d8e421b5b65b0a1.png"
          boxSize={123}
          dotColor="#ffffff"
          showDots
          className="absolute inset-0 w-full h-full"
        />
        {/* Index marker — bottom left */}
        <div className="absolute bottom-4 left-4 md:bottom-6 md:left-6 font-sans text-[10px] tracking-[0.18em] uppercase text-background-50 mix-blend-difference">
          № 001 — Archive
        </div>
      </div>
    </section>
  );
}